import { type Dispatch, type RefObject, type SetStateAction, useEffect } from 'react';

// TODO: cosider adding a threshold
const isContentTallerThanMaxHeight = (element: HTMLElement, maxHeight: number) => element.scrollHeight > maxHeight;

export const useIsExpandableEffect = ({
  contentReference,
  maxHeight,
  setIsExpandable,
}: {
  contentReference: RefObject<HTMLDivElement | null>;
  maxHeight: number;
  setIsExpandable: Dispatch<SetStateAction<boolean>>;
}) => {
  useEffect(() => {
    const element = contentReference.current;

    if (!element) {
      return;
    }

    const syncIsExpandable = () => {
      const isExpandable = isContentTallerThanMaxHeight(element, maxHeight);
      setIsExpandable(isExpandable);
    };

    syncIsExpandable();

    const resizeObserver = new ResizeObserver(() => {
      syncIsExpandable();
    });

    resizeObserver.observe(element);

    return () => {
      resizeObserver.unobserve(element);
    };
  }, [contentReference, maxHeight, setIsExpandable]);
};
